<div class="header content-card">
  <h2>{{ 'WF-EmploymentHistory' | translate }}</h2>

  <div class="row">
    <div class="col-12 col-lg-3">
      <button mat-raised-button color="primary" (click)="openModal()">{{ 'CreateEmploymentHistory' | translate
      }}</button>
    </div>
    <div class="col-12 col-lg-6">
      @if ((!workerFormContext || (workerFormContext && !workerFormApproved)) && !anyEmploymentHistoryEntry) {
        <mat-checkbox
          [disabled]="!workerFormContext" [checked]="skipEmploymentHistoryInformationChecked"
          (change)="onSkipEmploymentHistoryInformationChanged($event)" color="primary">{{
        'EmploymentHistorySkipInformationLabel' | translate }}</mat-checkbox>
      }
    </div>
  </div>
</div>
<div class="table-wrapper custom-table">
  <!-- Employment History's Table -->
  <mat-table #table matSort matSortActive="employmentDateFrom" matSortDirection="desc" matSortDisableClear
    [dataSource]="dataSource.employmentHistory$ | async">
    <!-- Employer Column -->
    <ng-container matColumnDef="employer" [sticky]="screenService.isAboveMd$ | async">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'FormerEmployer' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Employer }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="temporaryWorkEmployer">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        <div class="header-with-tooltip">
          {{ 'TemporaryWorkEmployer' | translate }}
          <mat-icon class="icon-md" matTooltip="{{ 'TemporaryWorkEmployerTooltip' | translate }}"
          matTooltipPosition="above"> info </mat-icon>
        </div>

        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="employer-cell">
        @if (!isEditing(element)) {
          <div class="display-container">
            @if (!isPossibleToEdit(element)) {
              <div>{{ element.TemporaryWorkEmployer }}</div>
            }
            @if (isPossibleToEdit(element) && isTemporaryWorkEmployerVisible()) {
              <div class="display-mode">
                <div class="employer-name">
                  {{ element.TemporaryWorkEmployer }}
                </div>
                <button mat-icon-button (click)="startEdit(element)" class="edit-button">
                  <mat-icon class="icon-sm">edit</mat-icon>
                </button>
              </div>
            }
          </div>
        }

        @if (isEditing(element) && temporaryWorkEmployerControl) {
          <div class="edit-container">
            <mat-form-field appearance="outline" class="edit-select">
              <mat-label>{{ 'TemporaryWorkEmployer' | translate }}</mat-label>
              <input matInput [formControl]="temporaryWorkEmployerControl" [matAutocomplete]="autocompleteEmployer" />
              <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue"
                (optionSelected)="saveTemporaryWorkEmployer(element, $event.option.value)">
                @if (searchPerformed) {
                  <mat-option [value]="null">
                    <em></em>
                  </mat-option>
                }
                @for (employer of temporaryWorkEmployers$ | async; track employer) {
                  <mat-option [value]="employer.Id">
                    {{ employer.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <button mat-icon-button (click)="finishEditing()">
              <mat-icon class="icon-sm">close</mat-icon>
            </button>
          </div>
        }
      </mat-cell>
    </ng-container>
    <!-- Employment Type Column -->
    <ng-container matColumnDef="employmentType">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'EmploymentType' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmploymentType }}</mat-cell>
    </ng-container>
    <!-- Address Column -->
    <ng-container matColumnDef="address">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'FormerEmploymentAddress' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Address }}</mat-cell>
    </ng-container>
    <!-- Employment Date From Column -->
    <ng-container matColumnDef="employmentDateFrom">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'EmploymentDateFrom' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmploymentDateFrom | date : 'yyyy-MM-dd' }}</mat-cell>
    </ng-container>
    <!-- Employment Date To Column -->
    <ng-container matColumnDef="employmentDateTo">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'EmploymentDateTo' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-cell>
    </ng-container>
    <!-- Working Time Column -->
    <ng-container matColumnDef="workingTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'WorkingTime' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.WorkingTime }}</mat-cell>
    </ng-container>
    <!-- Agreement Termination Method Column -->
    <ng-container matColumnDef="agreementTerminationMethod">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AgreementTerminationMethod' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.AgreementTerminationMethod ?? element.AgreementTerminationMode
      }}</mat-cell>
    </ng-container>
    <!-- Actions Column -->
    <ng-container matColumnDef="actions" stickyEnd>
      <mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (!isCreatedBySystem(element)) {
          <button mat-icon-button
            (click)="openModal(element)"><mat-icon>create</mat-icon></button>
          }
          @if (isCreatedBySystem(element)) {
            <button mat-icon-button (click)="openModal(element)">
              <mat-icon class="material-icons-outlined">visibility</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>